const qtyFormatter = new Intl.NumberFormat("sq-AL", { maximumFractionDigits: 2 });
const valueFormatter = new Intl.NumberFormat("sq-AL", { minimumFractionDigits: 0, maximumFractionDigits: 0 });

export default {
  methods: {
    formatQty(value) {
      const number = Number(value || 0);
      if (!number) return "0";
      return qtyFormatter.format(number);
    },
    formatValue(value) {
      const number = Number(value || 0);
      if (!number) return "0";
      return valueFormatter.format(number);
    },
    formatSigned(value) {
      const number = Number(value || 0);
      if (!number) return "0";
      return (number > 0 ? "+" : "") + qtyFormatter.format(number);
    },
    formatDateTime(value) {
      if (!value) return "-";
      const date = this.parseServerDate(value);
      if (isNaN(date.getTime())) return value;
      return date.toLocaleString("sq-AL", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
    },
    /** Laravel stores UTC without a Z; treat naive timestamps as UTC. */
    parseServerDate(value) {
      const raw = String(value).trim().replace(" ", "T");
      if (/Z$/i.test(raw) || /[+-]\d{2}:\d{2}$/.test(raw)) return new Date(raw);
      return new Date(raw + "Z");
    },
    /** "3 minuta më parë" style label for the last sync badge. */
    formatRelative(value) {
      if (!value) return "asnjëherë";
      const date = this.parseServerDate(value);
      if (isNaN(date.getTime())) return value;
      const seconds = Math.max(0, Math.round((Date.now() - date.getTime()) / 1000));
      if (seconds < 60) return "pak sekonda më parë";
      const minutes = Math.round(seconds / 60);
      if (minutes < 60) return minutes + (minutes === 1 ? " minutë më parë" : " minuta më parë");
      const hours = Math.round(minutes / 60);
      if (hours < 24) return hours + (hours === 1 ? " orë më parë" : " orë më parë");
      const days = Math.round(hours / 24);
      return days + (days === 1 ? " ditë më parë" : " ditë më parë");
    },
    /** Format a Date as the `YYYY-MM-DDTHH:mm` value a datetime-local input expects. */
    toLocalInput(date) {
      const pad = (n) => String(n).padStart(2, "0");
      return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate()) + "T" + pad(date.getHours()) + ":" + pad(date.getMinutes());
    },
  },
};
